import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { useMonthlyTask } from '@app/components/Calendars/components/MonthGrid/components/MonthlyTask/hooks';
import type { MonthlyTaskType } from '@app/components/Calendars/components/MonthGrid/components/MonthlyTask/types';

import '@app/components/Calendars/components/MonthGrid/components/MonthlyTask/styles/MonthlyTask.desktop.scss';

export const MonthlyTask: MonthlyTaskType = (task) => {
  const {
    style,
    taskTitle,
    openPreviewTaskModal,
    handleMouseEnter,
    handleMouseLeave,
    handleMouseDown,
    isDraggabled,
    isHovered,
    todayIsFirstDayInCurrentWeek,
    handleMouseUp,
  } = useMonthlyTask(task);
  return (
    <div
      className={`${CV_PREFIX}-monthly-task`}
      style={style}
      onClick={() => openPreviewTaskModal(+task.id)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      data-draggable={isDraggabled}
      data-status={task.status}
      data-draggabled={isDraggabled && todayIsFirstDayInCurrentWeek}
      data-hovered={isHovered && todayIsFirstDayInCurrentWeek}
      data-show={todayIsFirstDayInCurrentWeek}
      onMouseUp={handleMouseUp}
    >
      {taskTitle}
    </div>
  );
};
